import React from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'
import { _ChildAreaBox, _CloseBtn } from './styles'

const ChildAreaBox = ({ isSelected, area, onClick, onHover, onMouseLeave }) => (
  <_ChildAreaBox
    selected={isSelected}
    center
    onClick={onClick}
    onHover={onHover}
    onMouseLeave={onMouseLeave}
  >
    <div data-test-id="areaLabel">{area && area.label}</div>
    {
      isSelected && (
        <_CloseBtn data-test-id="childAreaBoxClose">
          <SvgIcon width={8} height={8} name={'#icon-slim-close'} />
        </_CloseBtn>
      )
    }
  </_ChildAreaBox>
)

ChildAreaBox.propTypes = {
  isSelected: PropTypes.bool,
  area: PropTypes.shape({
    areaType: PropTypes.string,
    areaId: PropTypes.number,
    label: PropTypes.string,
  }),
  onClick: PropTypes.func,
  onHover: PropTypes.func,
  onMouseLeave: PropTypes.func,
}

export default ChildAreaBox
